// Blog.js
import React from 'react';
import BlogSection from './BlogSection'; // make sure path is correct

const Blog = () => {
  return (
    <div className="page-container">
      <BlogSection /> {/* Shows the blog posts */}
    </div>
  );
};

export default Blog;
